import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';


import VueVideoPlayer from 'vue-video-player';

import 'video.js/dist/video-js.css'

Vue.use(VueVideoPlayer)


import { state, store } from './store';

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  data: {
    snackbar: {
      show: false,
      text: '',
      color: '#333',
      icon: 'mdi-information'
    },
    // Expose store state globally
    storeState: state
  },
  computed: {
    // Expose store globally
    store() {
      return store;
    }
  },
  methods: {
    showSnackbar(text, color = '#333', icon = 'mdi-information') {
      this.snackbar = { show: true, text, color, icon }
    }
  },
  render: h => h(App)
}).$mount('#app')
